export enum ApiOperationStatusEnum {
  ERROR,
  SUCCESS,
  CANCEL,
}
